import type { Action } from "createProposal/action/types"
import type { Maybe } from "query/graphql"

export enum VotingOptionStrategy {
  DEFAULT = "default",
  CUSTOM = "custom",
}

export enum StepName {
  CONNECT_WALLET,
  DETAILS,
  ACTIONS,
  SUMMARY,
  SELECTOR_GOVERNOR,
  IMPACT,
}

export enum CreateProposalType {
  GOVERNOR_PROPOSAL,
}

export type CreateProposalFormValues = {
  createProposalType: CreateProposalType
  details: {
    title: string
    description: string
    previewImageUrl?: string
    snapshotURL?: Maybe<string>
    discourseURL?: Maybe<string>
  }
  actions?: Action[]
  createOnChain?: boolean
  votingOption?: {
    strategy: VotingOptionStrategy
    supports?: string[]
    currentChoice: string
  }
}

export type CreateProposalFormState = {
  currentStep: StepName
  steps: StepName[]
  shouldRunSimulation: boolean | undefined
}
